import { Input, Space } from "antd"
import { SalesGoal } from "./salesModel"
import BudgetInputNumber from "./BudgetInputNumber"
import AddRemove from './AddRemove'
import BudgetStatistic from "./BudgetStatistic"
import BudgetTable from './BudgetTable'
import { useContext } from "react"
import BudgetCalculatorContext from "./BudgetCalculatorContext"

const Sales = () => {
  const { worksheet: { data: { salesGoals } }, summary, statistics, dispatch } = useContext(BudgetCalculatorContext)

  const columns = [
    {
      title: 'Cost Code',
      dataIndex: 'description',
      key: 'description',
      render: (value: string, _: SalesGoal, index: number) => {
        return <Input value={value} onChange={e => dispatch({ type: 'SALES_GOAL_DESCRIPTION_CHANGED', index, payload: e.target.value })} />
      }
    },
    {
      title: 'Annual Revenue',
      dataIndex: 'annualRevenue',
      key: 'annualRevenue',
      render: (value: number, _: SalesGoal, index: number) => {
        return <BudgetInputNumber
          value={value}
          money
          onChange={(e) => dispatch({ type: 'SALES_GOAL_ANNUAL_REVENUE_CHANGED', index, payload: e })} />
      }
    },
    {
      key: 'operations',
      render: (_: number, _record: SalesGoal, index: number) => {
        return <AddRemove
          onAdd={() => dispatch({ type: 'ADD_SALES_GOAL', index })}
          onRemove={() => dispatch({ type: 'REMOVE_SALES_GOAL', index })} />
      }
    }
  ]

  const differenceWithoutNegativeZeros = (): number => {
    const difference = summary.sales - statistics.salesGoal
    return Math.round(difference) === 0 ? 0 : difference
  }

  return <Space direction="vertical" size="large">
    <Space size="large">
      <BudgetStatistic title="Calculated Sales Target" value={statistics.salesGoal} statisticStyle="dollars" />
      <BudgetStatistic title="Sum of Cost Codes" value={summary.sales} statisticStyle="dollars" />
      <BudgetStatistic title="Difference" value={differenceWithoutNegativeZeros()} statisticStyle="dollars" />
    </Space>
    <BudgetTable
      columns={columns}
      dataSource={salesGoals}
    />
  </Space>
}
export default Sales
